import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaQs } from "../Landingpage/faq";

const Desktop26 = () => {
    const navigate = useNavigate();
    const [selectedFeature, setSelectedFeature] = useState(null);

    const features = [
        {
            id: 1,
            title: "ATS Readiness",
            description:
                "Check parseability, keyword strength, and formatting compliance with Applicant Tracking Systems.",
            icon: "🧾",
        },
        {
            id: 2,
            title: "Impact & Clarity",
            description:
                "Measure how effectively your achievements, results, and metrics are communicated.",
            icon: "💡",
        },
        {
            id: 3,
            title: "Skills & Job Fit",
            description:
                "See how well your resume aligns with your target job’s required competencies.",
            icon: "💼",
        },
        {
            id: 4,
            title: "Actionable Insights",
            description:
                "Receive examples, suggestions, and AI-generated rewrites to boost clarity and impact.",
            icon: "⚙️",
        },
    ];

    return (
        <div className="w-full min-h-screen overflow-x-hidden text-white flex flex-col items-center">
            {/* HERO SECTION */}
            <section className="relative w-full bg-gradient-to-b from-[#06010A] to-[#260345] flex flex-col md:flex-row items-center justify-between px-8 md:px-16 lg:px-24 py-24">
                {/* Decorative Background */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute w-[400px] h-[400px] bg-[#7B3FE4]/40 rounded-full blur-3xl top-[-100px] left-[-100px]" />
                    <div className="absolute w-[350px] h-[350px] bg-[#E6C1FF]/30 rounded-full blur-3xl bottom-[-150px] right-[-100px]" />
                </div>

                {/* Left Text */}
                <div className="relative z-10 max-w-xl text-white">
                    <h3 className="text-lg text-[#ffffffbf] mb-3">Resume Scoring</h3>
                    <h1 className="text-4xl md:text-5xl font-semibold leading-tight mb-6">
                        Get your resume scored instantly and uncover your career potential.
                    </h1>
                    <p className="text-gray-200 mb-8 text-base md:text-lg">
                        This AI-powered tool evaluates your resume against specific job descriptions and
                        industry benchmarks, delivering a quantitative score and actionable feedback to help you improve it
                    </p>

                    <button
                        onClick={() => navigate("/auth")}
                        className="bg-[#ffc403] text-black font-bold px-6 py-3 rounded-xl hover:bg-[#e6b800] transition"
                    >
                        Get Started
                    </button>
                </div>


                {/* Right Image */}
                <div className="relative z-10 mt-12 md:mt-0">
                    <img
                        src="https://c.animaapp.com/mge1sasxzrNszH/img/image-60.png"
                        alt="Resume Preview"
                        className="w-[350px] md:w-[450px] object-contain"
                    />
                </div>
            </section>

            {/* FEATURE BUBBLES SECTION */}
            <section className="w-full bg-white text-gray-900 py-24 px-6 md:px-20 text-center">
                <h2 className="text-3xl md:text-4xl font-bold mb-10">
                    Explore Your Resume Potential
                </h2>

                <div className="flex flex-wrap justify-center gap-10">
                    {[
                        {
                            id: 1,
                            title: "ATS Readiness",
                            description:
                                "Check parseability, keyword strength, and formatting compliance with Applicant Tracking Systems.",
                            icon: "🧾",
                        },
                        {
                            id: 2,
                            title: "Impact & Clarity",
                            description:
                                "Measure how effectively your achievements, results, and metrics are communicated.",
                            icon: "💡",
                        },
                        {
                            id: 3,
                            title: "Skills & Job Fit",
                            description:
                                "See how well your resume aligns with your target job’s required competencies.",
                            icon: "💼",
                        },
                        {
                            id: 4,
                            title: "Actionable Insights",
                            description:
                                "Receive examples, suggestions, and AI-generated rewrites to boost clarity and impact.",
                            icon: "⚙️",
                        },
                        {
                            id: 5,
                            title: "Objective Evaluation",
                            description:
                                "An unbiased score generated using proven hiring data and ATS algorithms.",
                            icon: "🛡️",
                        },
                        {
                            id: 6,
                            title: "Quick Uploads",
                            description:
                                "Submit your resume in any format (PDF, DOCX, TXT) and get results in seconds.",
                            icon: "📤",
                        },
                        {
                            id: 7,
                            title: "Problem Areas Identified",
                            description:
                                "Pinpoint weak sections like poor formatting, vague language, or missing keywords and fix them instantly.",
                            icon: "🧩",
                        },
                        {
                            id: 8,
                            title: "Smart Recommendations",
                            description:
                                "Get personalized suggestions on how to tailor your resume for specific roles and industries.",
                            icon: "🧠",
                        },
                    ].map((feature) => (
                        <div
                            key={feature.id}
                            onClick={() =>
                                setSelectedFeature(selectedFeature === feature.id ? null : feature.id)
                            }
                            className={`cursor-pointer rounded-full w-56 h-56 flex flex-col items-center justify-center text-center transition-all duration-300 shadow-md ${selectedFeature === feature.id
                                ? "bg-[#ffc403] text-black scale-105"
                                : "bg-gray-100 hover:bg-gray-200"
                                }`}
                        >
                            <div className="text-4xl mb-2">{feature.icon}</div>
                            <h4 className="font-semibold text-lg">{feature.title}</h4>
                            {selectedFeature === feature.id && (
                                <p className="mt-3 text-sm px-4">{feature.description}</p>
                            )}
                        </div>
                    ))}
                </div>
            </section>



        </div>
    );
};

export default Desktop26;
